module.exports = __webpack_public_path__ + "img/dash-orders-img.47fdd95e.svg";